import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaCommentDots, FaUserPlus } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import { STATUS_OPTIONS } from '../../Constant/leadConstent';
import LeadFilters from '../../common/leadFilter';
import Pagination from '../../common/Pagination';
import Swal from "sweetalert2";
import {
    assignLeadStore,
} from "../../redux/services/AssignTask Services/AssignTask.Services";
import { getstaffPendingLeadList, updateLeadStatus, deleteLead } from "../../redux/services/leadServices/Lead.Services"

function StaffPendingLeadList() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const role = localStorage.getItem("role");
    const isAdmin = role === "admin";
    const [leadData, setLeadData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalLeads, setTotalLeads] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [activeFilter, setActiveFilter] = useState("all");
    const [page, setPage] = useState(1);
    const limit = 100;
    const [showFilter, setShowFilter] = useState(false);
    const [selectedLeadIds, setSelectedLeadIds] = useState([]);
    const [assignLoading, setAssignLoading] = useState(false);
    const [userId, setUserId] = useState(null); // Add this state

    const handleDelete = async (id) => {
        try {
            const res = await deleteLead({
                id: id,
            });
            successToast(res?.message);
            const updatedLeads = leadData.filter(item => item.id !== id);
            setLeadData(updatedLeads); // Fix: Update state properly
        } catch (error) {
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "Delete failed"
            );
        }
    };
    const handlePageChange = (newPage) => {
        setPage(newPage);
        fetchLeads(newPage);
    };
    // Updated assign function with modal
    const handleAssignClick = () => {
        if (selectedLeadIds.length === 0) {
            return Swal.fire({
                title: "No Selection",
                text: "Please select at least one lead to assign",
                icon: "warning",
                confirmButtonText: "OK",
            });
        }
        dispatch(
            openModal({
                type: "assign-leads",
                title: "Assign Selected Leads",
                data: {
                    leadIds: selectedLeadIds,
                    onAssign: assignSelectedLeads,
                    isLoading: assignLoading,
                },
            })
        );
    };

    const assignSelectedLeads = async (userId) => {
        if (!userId) {
            return errorToast("Please select a staff member");
        }

        try {
            setAssignLoading(true);

            const payload = {
                user_id: userId,
                task_ids: selectedLeadIds,
            };
            const response = await assignLeadStore(payload);

            if (response?.status === true || response?.success === true) {
                // Remove assigned leads from list
                setLeadData(prev =>
                    prev.filter(lead => !selectedLeadIds.includes(lead.id))
                );
                setSelectedLeadIds([]);

                successToast(response?.message || "Leads assigned successfully 🚀");

                // Close modal if needed
                // You might want to dispatch close modal action here
            } else {
                errorToast(response?.message || "Assignment failed");
            }
        } catch (error) {
            console.error("Assignment Error:", error);
            errorToast(error?.response?.data?.message || "Assignment failed");
        } finally {
            setAssignLoading(false);
        }
    };

    // Fix: Handle select all with proper data reference
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const currentLeads = leadData || [];
            setSelectedLeadIds(currentLeads.map((l) => l.id));
        } else {
            setSelectedLeadIds([]);
        }
    };

    const toggleLeadSelection = (id) => {
        setSelectedLeadIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleStatusUpdate = async (data) => {
        try {
            await updateLeadStatus(data);
            Swal.fire({
                icon: "success",
                title: "Status Updated",
                text: "Lead status successfully updated!",
                timer: 1500,
                showConfirmButton: false
            });
            await fetchLeads(page);
        } catch (error) {
            console.log(error);
            errorToast("Status update failed");
        }
    };

    useEffect(() => {
        fetchLeads(1, true);
    }, []);

    const fetchLeads = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            const payload = {
                page: pageNo,
                per_page: limit,
            };
            const response = await getstaffPendingLeadList(payload);

    const result = response?.data || response;
            const leads = (response?.data || []).filter(
                (lead) => lead.status === "Pending"
            );
            setLeadData(leads);
            setPage(result?.current_page || 1);
            setTotalPages(result?.last_page || 1);
            setTotalLeads(result?.total || 0);
        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };

    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
    };

    if (initialLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
            </div>
        );
    }

    return (
        <div>
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
                <div className="ms-md-1 mb-2 mb-md-0">
                    <h4 className="fw-semibold mb-0">Pending Lead List</h4>
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item active">Pending Leads</li>
                    </ol>
                </div>
                {role === "admin" && (
                    <>
                        <button
                            onClick={() => navigate("/add-lead")}
                                className="lead-btn btn-add"
                        >
                            Add Lead
                        </button>

                        <button
                            className="btn btn-primary btn-sm"
                            onClick={() =>
                                dispatch(
                                    openModal({
                                        type: "import-lead",
                                        title: "Import Leads",
                                        data: null,
                                    })
                                )
                            }
                        >
                            Import Lead
                        </button>
                    </>
                )}
                {/* Add Assign Button */}
                {/* {selectedLeadIds.length > 0 && (
                    <button
                        className="btn btn-primary"
                        onClick={handleAssignClick}
                        disabled={assignLoading}
                    >
                        <FaUserPlus className="me-2" />
                        Assign Selected ({selectedLeadIds.length})
                    </button>
                )} */}
            </div>
            {totalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center flex-wrap">


                    {/* <div className="d-flex align-items-center">
                        <label className="mb-0">Show</label>
                        <select
                            className="form-select form-select-sm"
                            value={limit}
                            onChange={(e) => {
                                const newLimit = Number(e.target.value);
                                setLimit(newLimit);
                                setPage(1);
                                fetchLeads(1);
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div> */}

                    <div className="col-12 d-flex justify-content-end">

                        <Pagination
                            page={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>


                </div>
            )}

            <div className="st-wrapper-card">
                <div className="st-table-responsive">
                    <table className="table st-custom-table align-middle mb-0">
                        <thead>
                            <tr>
                                {/* <th>select</th> */}
                                <th>Sr.No.</th>
                                <th>Lead Id</th>
                                <th> Name</th>
                                <th> Mobile No</th>
                                <th> Source</th>
                                {/* <th> Assigned By</th>
                                {role === "admin" && <th>Assigned To</th>} */}
                                {/* <th>Assigned</th>
                                <th>Status</th>
                                <th>Remark</th> */}
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableLoading ? (
                                <tr>
                                    <td colSpan="6" className="text-center">
                                        Loading...
                                    </td>
                                </tr>
                            ) : (


                                leadData?.map((item, index) => (
                                    <tr key={item.id}>
                                        {/* <td>
                                        <input
                                            type="checkbox"
                                            checked={selectedLeadIds.includes(item.id)}
                                            onChange={() => toggleLeadSelection(item.id)}
                                        />
                                    </td> */}
                                        <td>{(page - 1) * limit + index + 1}</td>
                                        <td className="fw-semibold">{item?.name}</td>
                                        <td>{item.lead_id}</td>
                                        <td>{item.mobile}</td>
                                           <td>
                      <span
                        className={`source-badge ${item.source === "Website"
                          ? "website"
                          : item.source === "Facebook"
                            ? "facebook"
                            : item.source === "Justdial"
                              ? "instagram"
                              : item.source === "IndiaMART"
                                ? "indiamart"
                                : ""
                          }`}
                      >
                        {item.source}
                      </span>
                    </td>
                                        {/* <td>{item.assign_by?.name}</td>
                                    {role === "admin" && (
                                        <td>{item.assign_to?.name}</td>
                                    )} */}
                                        {/* <td>
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="whitedesign text-primary fw-semibold">
                                                By: {item.assign_by?.name || "-"}
                                            </span>

                                            <span>|</span>

                                            <span className="whitedesign text-success fw-semibold">
                                                To: {item.assign_to?.name || "-"}
                                            </span>
                                        </div>
                                    </td>
                                    <td className="fw-semibold">
                                        {item.status}
                                    </td>
                                    <td>
                                        <div className="remark-cell">
                                            {item.remarks}
                                        </div>
                                    </td> */}
                                        <td className="text-center">
                                             <div className="d-flex align-items-center justify-content-center gap-1">
    <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() => navigate(`/view-lead/${item.id}`)}
                                            >
                                                <FaEye />
                                            </button>

                                            {role === "admin" && (
                                                <button
                                                    className="st-action-btn st-delete-btn"
                                                    onClick={() =>
                                                        dispatch(
                                                            openModal({
                                                                type: "delete-lead",
                                                                title: "Delete Lead",
                                                                data: {
                                                                    id: item.id,
                                                                    deleteFunction: deleteLead,
                                                                    refreshData: () => fetchLeads(page),
                                                                },
                                                            })
                                                        )
                                                    }
                                                >
                                                    <FaTrash />
                                                </button>
                                            )}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() => navigate(`/remark-history/${item.id}`)}
                                            >
                                                <FaCommentDots />
                                            </button>
                                            </div>
                                        
                                        </td>
                                    </tr>
                                )))}
                        </tbody>
                    </table>
                    {totalPages > 1 && (
                        <div className="d-flex justify-content-end mt-3">
                            <Pagination
                                page={page}
                                totalPages={totalPages}
                                onPageChange={(newPage) => {
                                    setPage(newPage);
                                    fetchLeads(newPage);
                                }}
                            />
                        </div>
                    )}
                    
                </div>
            </div>
        </div>
    );
}

export default StaffPendingLeadList;